import PropTypes from 'prop-types'
import React from 'react'
import { ColorFilter } from 'Blocks'

const MobileColorsView = props => {
  return (
    <div className="price-filter__filter panel">
      <ColorFilter data={props.data} queryString={props.queryString} />
    </div>
  )
}

MobileColorsView.propTypes = {
  data: PropTypes.any,
  queryString: PropTypes.any
}

export default MobileColorsView
